/**
 * This file defines the routes used in the One App application.
 * It exports a constant object containing the route paths.
 */

const STATIC_ROUTES = {
  LANDING: '/',

  // User and Settings related routes
  PROFILE: '/profile',
  ONBOARDING_TEAM_INFORMATION: '/onboarding/team-information',
  CREATE_ADDITIONAL_TEAM: '/onboarding/team-information/new',
  ONBOARDING_USER_DETAILS: '/onboarding/user-details',
  ONBOARDING_SOCIAL_USER_DETAILS: '/onboarding/social-user-details',

  // Auth related routes
  LOGIN: '/auth/login',
  SIGNOUT: '/auth/logout',
  SIGNUP: '/auth/signup',
  LOGIN_WITH_TOKEN: '/auth/login-token',
  VERIFY_EMAIL: '/auth/verify-email',
  FORGOT_PASSWORD: '/auth/forgot-password',
  RESET_PASSWORD: '/auth/reset-password',
  ONBOARDING_SOCIAL_LANDING: '/auth/signup/landing',
  EMAIL_VERIFIED: '/auth/signup/email-verified',
  SOCIAL_LOGIN_LANDING: '/auth/login/landing',

  // Company and Insights related routes
  SWITCH_COMPANY: '/switch-company',
  CREATE_CONNECTION: '/create-connection',

  MAKE_ERROR: '/make-error',
} as const

const DYNAMIC_ROUTES = {
  OVERVIEW: '/:companyId',
  INSIGHTS: '/:companyId/insights',
  ACTIVITIES: '/:companyId/activities',
  INSIGHTS_DETAIL: '/:companyId/insights/:insightId',
  INSIGHTS_COMMENTS: '/:companyId/insights/:insightId/comments',
  DASHBOARDS: '/:companyId/dashboards',
  DASHBOARD_DETAIL: '/:companyId/dashboards/:reportId',
  BOOK_A_MEETING: '/:companyId/book-a-meeting',
  CONNECTIONS: '/:companyId/connections',
  ONBOARDING_CONNECTIONS: '/onboarding/connections/:companyId',
  CAMPAIGNS: '/:companyId/campaigns',
  ORGANIC_POSTS: '/:companyId/posts',
  POST_STUDIO: '/:companyId/posts/post-studio/:postSetId',
  MEDIA_LIBRARY: '/:companyId/media-library',
  CAMPAIGN_DETAIL: '/:companyId/campaigns/:campaignId',
  AD_STUDIO: '/:companyId/campaigns/:campaignId/ad-studio/:postSetId',
  CAMPAIGN_PUBLISH: '/:companyId/campaigns/:campaignId/publish',
  MARKETPLACE: '/:companyId/marketplace',
  KNOWLEDGE_HUB: '/:companyId/knowledge-hub',
  // MESSAGES: '/:companyId/messages',
  SHARED_REPORT: '/reports/:shareId',
  REPORT_PREVIEW: '/preview/:reportId',
  SETTINGS: '/:companyId/settings',
  DATA_EXPLORER: '/:companyId/data-explorer',
} as const

const API_PREFIX = '/api'

const LOOPING_ROUTES = [
  STATIC_ROUTES.SIGNOUT,
  STATIC_ROUTES.LOGIN,
  STATIC_ROUTES.SWITCH_COMPANY,
  STATIC_ROUTES.LANDING,
] as string[]

const REDIRECTS = {
  LOGIN: STATIC_ROUTES.LOGIN,
  LOGOUT: STATIC_ROUTES.SIGNOUT,
  AFTER_LOGIN: STATIC_ROUTES.SWITCH_COMPANY,
  VERIFY_EMAIL: STATIC_ROUTES.VERIFY_EMAIL,
  ONBOARDING_TEAM: STATIC_ROUTES.ONBOARDING_TEAM_INFORMATION,
  ONBOARDING_SOCIAL_USER_DETAILS: STATIC_ROUTES.ONBOARDING_SOCIAL_USER_DETAILS,
} as const

const API_ROUTES = {
  HEALTH: '/health',
  METRICS: `${API_PREFIX}/metrics`,
  PING: `${API_PREFIX}/ping`,
  READY: `${API_PREFIX}/ready`,
  STATUS: `${API_PREFIX}/status`,
  AUTH_COOKIE: `${API_PREFIX}/auth/cookie`,
  AUTH_COOKIE_CREATE: `${API_PREFIX}/auth/cookie/:name  `,
} as const

const PUBLIC_API_ROUTES = [
  API_ROUTES.HEALTH,
  API_ROUTES.PING,
  API_ROUTES.AUTH_COOKIE,
]

const ROUTES = {
  ...STATIC_ROUTES,
  ...DYNAMIC_ROUTES,
} as const

const PUBLIC_ROUTES = [
  STATIC_ROUTES.LOGIN,
  STATIC_ROUTES.SIGNOUT,
  STATIC_ROUTES.SIGNUP,
  STATIC_ROUTES.LOGIN_WITH_TOKEN,
  STATIC_ROUTES.VERIFY_EMAIL,
  STATIC_ROUTES.FORGOT_PASSWORD,
  STATIC_ROUTES.CREATE_CONNECTION,
  STATIC_ROUTES.ONBOARDING_USER_DETAILS,
  STATIC_ROUTES.ONBOARDING_SOCIAL_USER_DETAILS,
  STATIC_ROUTES.ONBOARDING_SOCIAL_LANDING,
  STATIC_ROUTES.SOCIAL_LOGIN_LANDING,
  STATIC_ROUTES.RESET_PASSWORD,
  STATIC_ROUTES.EMAIL_VERIFIED,
  ...PUBLIC_API_ROUTES,
] as string[]

export {
  LOOPING_ROUTES,
  API_PREFIX,
  PUBLIC_ROUTES,
  REDIRECTS,
  STATIC_ROUTES,
  DYNAMIC_ROUTES,
  ROUTES,
  API_ROUTES,
}
